module.exports = __webpack_public_path__ + "img/unamused-face.a4f07b8e.png";